<template>
    <div class="homepage-searchbar">
        <div class="search-switch-bar">
            <div class="search-switch-bar-title"
            :class="{ active: showContainer == 'hp'}"
            @click="changeShowContainer('hp')"
            data-type="hp">中国出发航线</div>
            <div class="search-switch-bar-title"
            :class="{ active: showContainer == 'row'}"
            @click="changeShowContainer('row')"
            data-type="row">海外出发航线</div>
        </div>

        <SearchBarContainer :cruiseType="'hp'" :cruiseFilters="cruiseFilters" :isContainerShow="showContainer=='hp'"/>
        <SearchBarContainer :cruiseType="'row'" :cruiseFilters="cruiseFilters" :isContainerShow="showContainer=='row'"/>
    </div>
</template>

<script>
const SearchBarContainer = () => import('@/components/Home/SearchBar/SearchBarContainer')

export default {
    name: 'SearchBar',
    components: {
        SearchBarContainer
    },
    props: {
        cruiseFilters: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    data () {
        return {
            showContainer: "hp"
        }
    },
    beforeMount () {
        this.$store.dispatch('RESET_CRUISE_FILTERS')
    },
    methods: {
        changeShowContainer(container) {
            if (this.container != container) {
                this.showContainer = container
            }
        }
    },
    computed: {

    }
}
</script>

<style>

/*搜索框*/
.homepage-searchbar{
    width: 345px;
    margin: -40px auto 30px;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    transition: top .5s linear;
    box-shadow: 0.643px 0.766px 26px 0px rgba(26, 32, 36, 0.28);
}

.homepage-searchbar .search-switch-bar {
    position: relative;
    /* display: flex; */
    width: 100%;
    margin: auto;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
}

.homepage-searchbar .search-switch-bar .search-switch-bar-title {
    background-color: rgba(40, 43, 44, 0.8);
    text-align: center;
    color: white;
    position: relative;
    z-index: 0;
    font-size: 15px;
    font-weight: normal;
    position: absolute;
    width: 50%;
    height: 100%;
    left: 0;
    bottom: 0;
}

.homepage-searchbar .search-switch-bar .search-switch-bar-title:nth-child(2) {
    right: 0;
    left: auto;
}


.homepage-searchbar .search-switch-bar .search-switch-bar-title.active {
    background: url(https://resource.rcclchina.com.cn/cruiseSearch/mb-search-switch-selected.png);
    background-size: 100% 100%;
    color: #0073bb;
    z-index: 1;
    font-weight: bold;
    width: 186px;
    height: 45px;
    line-height: 45px;
}

.homepage-searchbar .search-switch-bar .search-switch-bar-title.active:nth-child(2) {
    background: url(https://resource.rcclchina.com.cn/cruiseSearch/mb-search-switch-selected-2.png);
    background-size: 100% 100%;
}

.homepage-searchbar .search-wrapper{
    width: 100%;
    height: 290px;
    margin: 0 auto;
    background: #fff;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    position: relative;
    /*top: -22px;*/

    z-index: 3;
    padding: 0 20px;

}
.homepage-searchbar .search-wrapper .search-comm{
    display: block;
    justify-content: space-between;
    border-bottom: 1px solid #d4dbde;
    height: 70px;
    padding: 25px 0 25px 0;
    box-sizing: border-box;
    color:#282b2c;
    font-size: 15px;
}

.homepage-searchbar .search-has-item .search-item-title {
    display: block;
    color: #747d80;
    font-size: 12px;
    position: relative;
    margin-top: -12px;
}



.homepage-searchbar .badge {
    background-color: #0073bb;
    font-size: 10px;
    margin-left: 5px;
    /* padding: 0 7px; */
    display: inline;
    padding: 0 5px;
}

.homepage-searchbar .search-item-content {
    display: block;
    width: 270px;
    position: relative;
    top: 5px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}

.homepage-searchbar .search-wrapper .search-comm>img{
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    float: right;
    position: relative;
    top: -23px;
}

/* .homepage-searchbar img {
    position: relative;
    top: -23px;
} */

.homepage-searchbar .search-wrapper .search-dest{
    margin-bottom: 10px;
}
.homepage-searchbar .search-wrapper .search-btn{
    display: block;
    width: 305px;
    height: 50px;
    margin:0 auto;
    line-height: 50px;
    text-align:center;
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    background: #0073bb;
}

.cruise_search .search-form-list-item.cruiseDisable span
, .cruise_search .search-form-list-item.disable span
, .date-wrapper .date-content .date-table .table-cell.disable{
    color: rgba(204,204,204,1);
    cursor: not-allowed;
}




/*弹窗样式*/
.popup{
    overflow-y: hidden;
}
.area-country{
    display:none;
    padding-bottom: 102px;
}
.area-country.active{
    display: block;
}
.popup-head{
    position: absolute;
    width: 100%;
    text-align: center;
    height: 54px;
    line-height: 54px;
    background-color: #0073bb;
    color: #fff;
    z-index: 10;
    letter-spacing: 1px;
}
 .popup-head img{
    position: absolute;
    top: 13px;
    left: 15px;
    width: 14px;
}


.panel-left-comm .dest-area{
    /*display: flex;
    flex-wrap: wrap;*/
    /* background: #f5f5f5; */
}
.area-country-select{
    float: right;
    background: #fff;
    height: 100%;
    overflow:scroll;
}
.panel-left-comm .dest-area .area-select {
    width: 82px;
    background: #f5f5f5;
    float: left;
    position: relative;
    height: 100%;
}
.dest-area{
    height: 100%;
    overflow-y: auto;
    margin-top: 54px;
    background-color: #fff;
}
.dest-area .area-select div.active{
    background: #fff;
}
.dest-area .area-select>div{
    width: 100%;
    height: 70px;
    text-align: center;
    font-size: 12px;
    color: #282b2c;
    display: flex;
    align-items: center;
    position: relative;
}
.dest-area img,.panel-left-dateTime img{
    display: inline-block;
}
.dest-area .area-country ul{
    width: 293px;
}

.search-form-container .area-select .area-select-line {
    display: none;
    position: absolute;
    width: 5px;
    height: 50px;
    top: 10px;
    background-color: #fbc500;
}

.search-form-container .area-select .active .area-select-line {
    display: block;
}

.popup-dest .area-country-select {
    background: transparent;
}

.popup-dest .area-country-select .area-country .area-country-name {
    border-radius: 5px;
    background-color: rgb(84, 163, 222);
    width: 273px;
    height: 33px;
    line-height: 33px;
    font-size: 12px;
    color: white;
    margin: 0px auto 0 auto;
    padding: 0 20px;
    position: relative;
}

.popup-dest .area-country-select .area-country .area-country-name img {
    width: 11px;
    position: absolute;
    right: 20px;
    top: 10px;
    transform: rotate(180deg);
}

.popup-dest .area-country-select .area-country .area-country-content {
    width: 293px;
    background-color: #fff;
    padding: 8px 0px;
    /* margin-bottom: 5px; */
}

.popup-dest .area-country-select .area-country .area-country-content-line {
    width: 100%;
    height: 5px;
    background-color: #f5f5f5;
}

.popup-dest .area-country-select .area-country .area-country-content.active .area-country-name img {
    transform: rotate(0deg);
}

.popup-dest .area-country-select .area-country ul {
    display: none;
}

.popup-dest .area-country-select .area-country .area-country-content.active ul {
    display: block;
}


.dest-area .area-country ul.country-large {
    width: 375px;
}

.dest-area .area-country ul li.country-name{
    background: #eef8ff;
}
.dest-area .area-country ul li:last-child{
    border-bottom: 0px;
}
.dest-area .area-country ul li.active span{
    color: #0073bb;
}
.dest-area .area-country ul li.active .selected{
    display: block;
}
.dest-area .area-country ul li{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #fff;
    border-bottom: 1px solid #e9edee;
    box-sizing: border-box;
    position: relative;
}

.dest-area .area-country ul li img.flag {
    width: 25px;
    vertical-align: middle;
    margin-left: 5px;
    border: 1px solid;
    border-color: rgba(233, 237, 238, 1);
}

.dest-area .area-country ul li img.flag.no-border {
    border: none;
}

.dest-area .area-country ul li img.selected{
    width: 20px;
    position: absolute;
    top: 20px;
    right: 30px;
    display:none;
}
.dest-area .select-fir .area-country ul li:first-child span{
    font-size: 15px;
}
.dest-area .area-country ul li span{
    font-size: 15px;
    color: #282b2c;
    margin-left: 25px;
}
.dest-area .area-country ul li img.tag {
    width: 36px;
    vertical-align: -2px;
    position: relative;
    top: 2px;
    border: 1px solid;
    border-color: rgba(233, 237, 238, 1);
}

.search-form-container .area-select-name {
    margin: auto;
    color: #747d80;
    font-weight: normal;
}

.search-form-container .area-select .active .area-select-name {
    font-weight: bold;
    color: #282b2c;
}

.dest-area .area-country ul li img.tag.special {
    width: 25px;
    vertical-align: -2px;
    position: relative;
    top: 4px;
}

.select-num {
    position: absolute;
    top: 7px;
    right: 7px;
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    color: #fff;
    background: #0073bb;
    text-align: center;
    line-height: 14px;
}

.click-btn{
    width: 100%;
    height: 49px;
    display: flex;
    /* margin-bottom: 18px; */
    border-top: 1px solid #e9edee;
    position: fixed;
    left: 0;
    bottom: 0;
}
.click-btn a{
    display: block;
    width: 50%;
    text-align: center;
    line-height: 49px;
    font-size: 15px;
    color: #282b2c;
}
.click-btn .reset-btn{
    background: #fff;
}
.click-btn .reset-btn>img{
    width: 15px;
    vertical-align: -2px;
}
.click-btn .define-btn{
    background:#fbc500;
}
.click-btn .define-btn>img{
    width: 20px;
    vertical-align: -2px;
}

.panel-left-dateTime .date-wrapper{
    /*border-bottom: 1px solid #d3dadd;*/
    margin-top: 54px;
    height: 100%;
    overflow-y: auto;
    position: absolute;
    width: 100%;
    padding-bottom: 102px;
}
.panel-left-dateTime .date-wrapper .date-content{
    width: 100%;
}
.date-wrapper .date-content .year{
     width: 100%;
     height:35px;
     line-height:35px;
     text-align: center;
     font-size:15px;
     color:#282b2c;
     background: #f5f5f5;
}
.date-wrapper .date-content .date-table{
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 13px 15px;
}
.date-wrapper .date-content .date-table .table-row{
    width: 100%;
    margin-bottom: 21px;
    display: flex;
    justify-content: space-between;
}
.date-wrapper .date-content .date-table .table-row:last-child{
    margin-bottom: 6px;
}
.date-wrapper .date-content .date-table .table-cell{
    width: 78px;
    height: 41px;
    line-height: 41px;
    font-size: 14px;
    color: #282b2c;
    text-align: center;
}
.date-wrapper .date-content .date-table .table-cell.active{
    background: #0073bb;
    color: #fff;
}

.panel-left-setout .dest-area .area-country ul li:first-child{
    background:#fff;
}

#app .popup {
    display: block;
     position: fixed;
    transform: translate3d(100%, 0, 0);
    transition: 0.3s;
    /* display: none; */
}

#app .popup.in, #app .popup.modal-in {
    transform: translate3d(0, 0, 0);
    display: block;
}

#app .popup.modal-out {
    transform: translate3d(100%, 0, 0);
    display: none;
}

</style>
